import { Row } from 'antd';
import BannerCard from '../../Atoms/BannerCard';
import Styles from './BannerSearch.module.scss';
import { TBannerSearch } from './definitions';

export default function BannerSearch({ bannerData }: TBannerSearch) {
  return (
    <Row
      align="middle"
      justify="space-between"
      className={Styles['banner-search']}
    >
      {bannerData.map((data) => (
        <BannerCard key={data.name} data={data} />
      ))}
    </Row>
  );
}
